var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("section-title", { attrs: { icon: "mdi-clipboard-plus-outline" } }, [
        _vm._v("INFORMES DE SALUD Y GESTIÓN DEL ÚLTIMO AÑO")
      ]),
      _c(
        "v-fade-transition",
        [
          _vm.isLoading
            ? _c(
                "v-row",
                { staticClass: "my-4" },
                _vm._l(4, function(k) {
                  return _c(
                    "v-col",
                    { key: k, attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-skeleton-loader", {
                        attrs: { height: "110", loading: "", type: "image" }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _c(
                "v-row",
                { staticClass: "my-4" },
                _vm._l(_vm.reports, function(report, k) {
                  return _c(
                    "v-col",
                    { key: k, attrs: { cols: "12", md: "6" } },
                    [_c("health-report-box", { attrs: { report: report } })],
                    1
                  )
                }),
                1
              )
        ],
        1
      ),
      _vm.reports.length === 0 && !this.isLoading
        ? _c(
            "v-container",
            {
              staticClass: "empty-state",
              attrs: {
                "pa-0": "",
                "ma-0": "",
                fluid: "",
                "justify-center": "",
                "fill-height": ""
              }
            },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/empty-state-reports.png"),
                    alt: "No hay informes para listar"
                  }
                }),
                _c("p", [_vm._v("No hay informes para listar")])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }